import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {FindVehicleClaimComponent} from "./find-vehicle-claim.component";

const routes: Routes = [{ path: '', component: FindVehicleClaimComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FindVehicleClaimRoutingModule {}
